// FIXME: Can't use shortened version `src/helpers`, because there is a cyclic dependency between the constants and
//        helpers folder.
import { fromEnv } from "src/helpers/fromEnv";

export const TNC_VERSION = {
  GOBIZ: {
    VERSION: "v11.2020",
    REVISION: 2,
  },
  GOFOOD: {
    VERSION: "v01.2020",
    REVISION: 1,
  },
  GOPAY: {
    VERSION: "v01.2020",
    REVISION: 1,
  },
  SPOTS_AGGREGATOR: {
    VERSION: "v07.1.2020",
    REVISION: 1,
  },
  SPOTS_POS: {
    VERSION: "v01.2020",
    REVISION: 1,
  },
  CLAIM_ADMIN: {
    VERSION: "v07.2020",
    REVISION: 1,
  },
  MANUAL_PAYOUT: {
    VERSION: "v09.2020",
    REVISION: 1,
  },
  GOFOOD_SOP: {
    VERSION: "v01.2021",
    REVISION: 2,
  },
  GOPAY_SOP: {
    VERSION: "v01.2021",
    REVISION: 2,
  },
  POS: {
    VERSION: "v05.2020",
    REVISION: 1,
  },
  MIDTRANS: {
    VERSION: "v08.2026",
    REVISION: 1,
  },
};

export type TnCVersionType = typeof TNC_VERSION;

const appHost = fromEnv("REACT_APP_TNC_HOST");

export const TNC_FILES = {
  GOBIZ: `${appHost}/terms-and-condition/gobiz-${TNC_VERSION.GOBIZ.VERSION}`,
  GOFOOD: `${appHost}/terms-and-condition/gofood-${TNC_VERSION.GOFOOD.VERSION}`,
  GOJEK_PRIVACY_POLICY: "https://www.gojek.com/privacy-policy",
  GOPAY: `${appHost}/terms-and-condition/gopay-${TNC_VERSION.GOPAY.VERSION}`,
  SPOTS_AGGREGATOR: `${appHost}/terms-and-condition/spots-aggregator-${TNC_VERSION.SPOTS_AGGREGATOR.VERSION}`,
  SPOTS_POS: `${appHost}/terms-and-condition/spots-pos-${TNC_VERSION.SPOTS_POS.VERSION}`,
  CLAIM_ADMIN: `${appHost}/terms-and-condition/ownership-${TNC_VERSION.CLAIM_ADMIN.VERSION}`,
  POS: `${appHost}/terms-and-condition/pos-${TNC_VERSION.POS.VERSION}`,
  GOFOOD_SOP: `${appHost}/terms-and-condition/gofood-sop-${TNC_VERSION.GOFOOD_SOP.VERSION}`,
  GOPAY_SOP: `${appHost}/terms-and-condition/gopay-sop-${TNC_VERSION.GOPAY_SOP.VERSION}`,
  MIDTRANS: `${appHost}/files/terms-and-condition/pdf/midtrans-${TNC_VERSION.MIDTRANS.VERSION}.pdf`,
};
